import { getAccessToken } from '../authentication/supabaseService';

export interface TeamMember {
  id: string;
  name: string | null;
  email: string;
  profile_picture_url: string | null;
}

/**
 * Fetch all team members (admin + staff) for the current user's organization.
 * Returns minimal data needed for displaying user info.
 */
export async function fetchTeamMembers(): Promise<TeamMember[]> {
  const token = await getAccessToken();
  const res = await fetch('/api/users/team-members', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch team members: ${res.statusText}`);
  }
  return (await res.json()) as TeamMember[];
}
